<template>  
    
    <div class="container-fluid">

        <!-- start page title -->
        <div class="row">
            <div class="col-xl-12 col-lg-12">

                <div class="row">
                    <div class="col-sm-3">
                        <div class="card widget-flat">
                            <div class="card-body">
                                <div class="float-end">
                                    <i class="mdi mdi-account-multiple widget-icon"></i>
                                </div>
                                <h5 class="text-muted fw-normal mt-0" title="Number of Customers">Today Total Sales </h5>
                                <h3 class="mt-3 mb-3"> {{ items.todaySalesAmount ? items.todaySalesAmount : 0 }}</h3>
                                <!-- <p class="mb-0 text-muted">
                                    <span class="text-success me-2"><i class="mdi mdi-arrow-up-bold"></i> 5.27%</span>
                                    <span class="text-nowrap">Today Sales Amount</span>  
                                </p> -->
                            </div> <!-- end card-body-->
                        </div> <!-- end card-->
                    </div> <!-- end col-->

                    <div class="col-sm-3">
                        <div class="card widget-flat">
                            <div class="card-body">
                                <div class="float-end">
                                    <i class="mdi mdi-cart-plus widget-icon"></i>
                                </div>
                                <h5 class="text-muted fw-normal mt-0" title="Number of Orders">Number of Pending Order</h5>
                                <h3 class="mt-3 mb-3">{{ items.pendingOrder ? items.pendingOrder : 0 }}</h3>
                                <!-- <p class="mb-0 text-muted">
                                    <span class="text-danger me-2"><i class="mdi mdi-arrow-down-bold"></i> 1.08%</span>
                                    <span class="text-nowrap">Since last month</span>
                                </p> -->
                            </div> <!-- end card-body-->
                        </div> <!-- end card-->
                    </div> <!-- end col-->
                 
                    <div class="col-sm-3">
                        <div class="card widget-flat">
                            <div class="card-body">
                                <div class="float-end">
                                    <i class="mdi mdi-currency-usd widget-icon"></i>
                                </div>
                                <h5 class="text-muted fw-normal mt-0" title="Average Revenue">Monthly Total Sales</h5>
                                <h3 class="mt-3 mb-3">{{ items.currentMonthSalesAmount ? items.currentMonthSalesAmount : 0}}</h3>
                                <!-- <p class="mb-0 text-muted">
                                    <span class="text-danger me-2"><i class="mdi mdi-arrow-down-bold"></i> 7.00%</span>
                                    <span class="text-nowrap">Since last month</span>
                                </p> -->
                            </div> <!-- end card-body-->
                        </div> <!-- end card-->
                    </div> <!-- end col-->

                    <div class="col-sm-3">
                        <div class="card widget-flat">
                            <div class="card-body">
                                <div class="float-end">
                                    <i class="mdi mdi-pulse widget-icon"></i>
                                </div>
                                <h5 class="text-muted fw-normal mt-0" title="Growth">Yearly Total Sales</h5>
                                <h3 class="mt-3 mb-3">{{ items.currentYearSalesAmount ? items.currentYearSalesAmount : 0}}</h3>
                                <!-- <p class="mb-0 text-muted">
                                    <span class="text-success me-2"><i class="mdi mdi-arrow-up-bold"></i> 4.87%</span>
                                    <span class="text-nowrap">Since last month</span>
                                </p> -->
                            </div> <!-- end card-body-->
                        </div> <!-- end card-->
                    </div> <!-- end col-->
                </div> <!-- end row -->

            </div> <!-- end col --> 
        </div>

 
        <!-- end page title -->
  
    </div>  
</template>
<script type="text/javascript">
import {mapGetters, mapActions} from "vuex"; 
import {ref, onMounted, getCurrentInstance } from "vue";
import Form from "vform";
import axios from "axios";  
export default {
    name: "Dashboard",
    components: { 
    },
    data() {
        return { 
            errors: {},
            btn:'Create',
            items: [],
            counter: {
                customer_count: 0,
                order_count: 0,
                supplier_count: 0,
                product_count: 0,
            }, 
            options: {
                chart: {
                id: 'vuechart-example'
                },
                xaxis: {
                categories: ['Saturday', 'Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday']
                }
            },
            series: [{
                name: 'series-1',
                data: [30, 40, 45, 50, 49, 60, 70]
            }]
        }
    }, 
    
    created() {   
        this.checkLogin(); 
        this.fetchCounterData();
    },
    methods: {

	    checkLogin: function(e){ 
            const app = getCurrentInstance();
            app.appContext.config.globalProperties.headers = {headers: {
              'Authorization' : this.$store.getters.token ? `Bearer ${this.$store.getters.token}` : "",
              'Content-Type': 'multipart/form-data' 
            }};

            app.appContext.config.globalProperties.headerjson = {headers: {
              'Authorization' : this.$store.getters.token ? `Bearer ${this.$store.getters.token}` : "",
              'Content-Type': 'application/json' 
            }};
            
	    	if(!this.$store.getters.token){
	      		window.location.href = "/login"   
		    } 

		},

        fetchCounterData() {
            axios.get(this.apiUrl+'/dashboard', this.headerjson)
            .then((resp) => {
                this.items = resp.data.data;
                console.log('items', resp.data.data);
            })
            .catch((err) => {
                this.$toast.error(err.response.data.message);
            })
        }
	},
    computed:{
        ...mapGetters([
          'userData',
          'token'
        ]), 
    } 
};
	
</script>

<style scoped>
.card.widget-flat {
  background-color: #313a46;
}
.card-body{
    color:white;
}
</style>